import React, {useMemo} from 'react';
import {Card} from 'antd';
import EtfHeader from "./EtfHeader";
import EtfStepLine from "./EtfStepLine";
import EtfTable from "./EtfTable";
import useColorPicker from "../../../hooks/useColorPicker";
import { setEtfColors } from "../../../store/slices/appState.slice";


/**
 * Position component for displaying ETF data for a single ETF
 * @param etf {Object} ETF document containing etf holdings array of objects
 * @param onCheck {function} Callback function for checkbox check event
 * @param onRemove {function} Callback function for remove button click event
 * @param checkboxProps {Object} Object containing checkbox properties
 * @param colormap {Object} Object containing sector-color mapping
 * @param mode {string} Mode of the component, 'full' or 'compact'
 * @param filters {Object, optional} Object containing filters with keys 'search' and 'sector'. Each will be empty
 * array unless one or more ticker and/or sector filters are applied.
 * @returns {JSX.Element}
 * @constructor
 */
const EtfPositions = ({ etf, onCheck, onRemove, checkboxProps,
                      sectorColors, mode='full', filters, etfColor, background }) => {
    const tickerList = etf?.holdings || [];
    let isChecked = checkboxProps?.isChecked && checkboxProps.symbol === etf.symbol;
    const [color, handleColorUpdate] = useColorPicker(etf.symbol, etfColor, setEtfColors);
    const filteredTickerList = useMemo(() => {
        let tickerList = etf?.holdings || [];

        // If both filters are empty, return the full list
        if (filters.search.length === 0 && filters.sector.length === 0) {
            return tickerList;
        }

        return tickerList.filter(holding => {
            const symbolMatch = filters.search.length === 0 ||
                filters.search.some(search =>
                    holding.symbol.toLowerCase().includes(search.toLowerCase())
                );

            const sectorMatch = filters.sector.length === 0 ||
                filters.sector.includes(holding.sector);

            return symbolMatch && sectorMatch;
        });
    }, [etf?.holdings, filters]);




    return (
        <Card
            className={isChecked?'dropped-shadow-gapless':'gapless'}
            style={{background, borderRadius: 0}}
            bordered={false}
            title={
                <EtfHeader
                          name={etf?.name}
                          symbol={etf?.symbol}
                          onCheck={() => onCheck(etf?.symbol)}
                          onRemove={() => onRemove(etf?.symbol)}
                          isChecked={isChecked}
                          logoUrl={etf?.logo}
                          color={color}
                          handleColorUpdate={handleColorUpdate}
                          holdingsCount={tickerList.length}
                />
            }
        >
            {mode === 'full' && (
                <div className={'mt-3'}>
                    <EtfStepLine tickerList={tickerList} />

                </div>
            )}
            <div className={'px-3'}>
                <EtfTable
                    tickerList={filteredTickerList}
                    selectedTickers={checkboxProps?.tickerList || []}
                    isSelected={checkboxProps.symbol===etf?.symbol&&checkboxProps.isChecked}
                    sectorColors={sectorColors}
                />
            </div>
        </Card>
    );
};

export default EtfPositions;
